<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import WKSDK from "wukongimjssdk"
export default {
  name: 'App',
  created() {
    console.log('upload Date:', new Date())
  },
  mounted() {
    this.initIm()
  },
  beforeDestroy() {
    console.log('断开连接')
    WKSDK.shared().connectManager.disconnect();
  },
  methods: {

    initIm() {
      const token = localStorage.getItem("token")
      if (!token) {
        return
      }

      let t = this;
      this.$get(
        {
          context: t,
          path: '/im/login/',
          params: {},
          success: function (data) {
            console.log(data)
            if (data.uid) {
              WKSDK.shared().config.addr = data.api;
              WKSDK.shared().config.uid = data.uid;
              WKSDK.shared().config.token = data.token;
              WKSDK.shared().connectManager.connect();
              WKSDK.shared().connectManager.addConnectStatusListener(
                (status, reasonCode) => {
                  console.log(status)
                  if (status === 1) {
                    console.log('连接成功');
                  } else {
                    console.log('连接失败', reasonCode); //  reasonCode: 2表示认证失败（uid或token错误）
                  }
                },
              );

            }
          }
        }
      )
    }
  }
}
</script>

<style>

/*@import 'assets/global.css';*/

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0
}

.el-header, .el-footer {
  background-color: #4f575f;
  color: #cee5fb;
  text-align: left;
  line-height: 60px;
}

.el-aside {
  background-color: transparent;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: transparent;
}


/*body > .el-container {*/
/*margin-bottom: 40px;*/
/*}*/

/*.el-container:nth-child(5) .el-aside,*/
/*.el-container:nth-child(6) .el-aside {*/
/*line-height: 260px;*/
/*}*/

/*.el-container:nth-child(7) .el-aside {*/
/*line-height: 320px;*/
/*}*/

/*项目定义*/
.bottom_space {
  margin-bottom: 30px;
}

a {
  text-decoraction: none;
}

.router-link-active {
  text-decoration: none;
}


</style>
